import { render, staticRenderFns } from "./day-sh.vue?vue&type=template&id=52c00513&scoped=true&"
import script from "./day-sh.vue?vue&type=script&lang=js&"
export * from "./day-sh.vue?vue&type=script&lang=js&"
import style0 from "./day-sh.vue?vue&type=style&index=0&id=52c00513&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c00513",
  null
  
)

export default component.exports